import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../../redux/hooks';
import useQuestionnaires from '../../../hooks/queries/useQuestionnaires';

import LifeStyleComponent from './component';

import { HISTORY_TYPE } from '../../../constants';

const LifeStyle: React.FC = () => {
  const navigate = useNavigate();
  const [isQuestionnaireComplete, setIsQuestionnaireComplete] =
    useState<boolean>(true);

  const { id: patientId } =
    useAppSelector((state) => state.auth.currentUser) || {};

  const { questionnaires } = useQuestionnaires({
    type: HISTORY_TYPE.LIFESTYLE,
    patientId,
  });

  const toggleQuestionnaireCompletion = () =>
    setIsQuestionnaireComplete((prevState) => !prevState);

  const navigateToTasks = () => navigate('/tasks');

  return (
    <LifeStyleComponent
      isQuestionnaireComplete={isQuestionnaireComplete}
      questionnaires={questionnaires}
      toggleQuestionnaireCompletion={toggleQuestionnaireCompletion}
      navigateToTasks={navigateToTasks}
    />
  );
};

export default LifeStyle;
